import { Component, OnInit } from '@angular/core';
import { FiltrosCustosService } from '../../../../filters/filtros-custos.service';
import { IntegradorService } from '../../../../services/integrador.service';

@Component({
  selector: 'app-custodespesageral',
  templateUrl: './custodespesageral.component.html',
  styleUrl: './custodespesageral.component.css',
})
export class CustodespesageralComponent implements OnInit {
  despesas: any[] = [];
  totalRecords: number = 0;
  loading: boolean = false;

  dataInicio: string = '';
  dataFim: string = '';
  instancia: string = '';

  constructor(
    private integradorService: IntegradorService,
    private filterService: FiltrosCustosService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.despesas = []

    this.getFiltros()
  }

  getFiltros(){
    this.filterService.currentInstancia.subscribe((instancia) => {
      this.instancia = instancia;
      this.loadDespesas({
        first: 0,
        rows: 10,
        sortField: 'cdEmpresaErp',
        sortOrder: 1,
      });
    });

    this.filterService.currentDataInicio.subscribe((inicio) => {
      this.dataInicio = inicio;
      this.loadDespesas({
        first: 0,
        rows: 10,
        sortField: 'cdEmpresaErp',
        sortOrder: 1,
      });
    });

    this.filterService.currentDataFim.subscribe((fim) => {
      this.dataFim = fim;
      this.loadDespesas({
        first: 0,
        rows: 10,
        sortField: 'cdEmpresaErp',
        sortOrder: 1,
      });
    });
  }

  loadDespesas(event: any) {

    if (this.instancia != '' && this.dataInicio != '' && this.dataFim != '') {
      this.loading = true;
      const sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';

      this.integradorService
        .getDespesasGeral(
          event.first / event.rows,
          event.rows,
          event.sortField,
          sortDirection,
          this.instancia,
          this.dataInicio,
          this.dataFim
        )
        .subscribe((data) => {
          this.despesas = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        });
    }else{
      this.loading = false;
    }
  }
}
